/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import React from 'react';
import {fetchFeed} from '../apiFunctions';
import T from 'i18n-react';
import Spinner from "./modal/spinner.jsx";
import Infobox from "./infobox.jsx";
import {setFocusedPuff} from '../actions/puff';
import { connect } from 'react-redux';
// import Discover from './discover.jsx';
import Config from './feed/config';
class Linear extends React.Component {

  constructor(props){
    super(props);

    this.onScroll = this.onScroll.bind(this);
    this.addMoreElements = this.addMoreElements.bind(this);
    this.scrollEventHandler = this.throttle(this.onScroll,20);


    this.visibleELements = [];
    // this.myRef = React.createRef()
    this.state={
      chunkSize:3,
      chunkOffset:0,
      containers:[],
      reset:false,
      top:true
    }
  }

  throttle(fn, wait) {
    var time = Date.now();
    return function(event) {
      if ((time + wait - Date.now()) < 0) {
        fn(event);
        time = Date.now();
      }
    }
  }

  componentDidMount () {
    this.refs.linearContainer.addEventListener('scroll',this.scrollEventHandler)
    this.addMoreElements(true, 2);
  }

  componentWillUnmount () {
    this.refs.linearContainer.removeEventListener('scroll',this.scrollEventHandler)
  }

  // componentWillUpdate(prevProps,prevState){
  //   if(prevProps.selectedPuff.id!==this.props.selectedPuff.id &&
  //  prevProps.selectedPuff.scrollId===this.props.scrollId &&
  //  this.props.selectedPuff.id!==0 &&
  //  prevProps.selectedPuff.id!==0  ){

  //     const prevPuffDom = document.getElementById(prevProps.selectedPuff.id)
  //     const prevPuffHeightNow = parseFloat(getComputedStyle(prevPuffDom).height)

  //     // console.log("Mine")
  //     // console.log(this.props.scrollId)
  //     // console.log("getting")
  //     // console.log(this.props.selectedPuff)
  //     // console.log("prev")
  //     // console.log(prevProps.selectedPuff.id)
  //     // console.log("now")
  //     // console.log(this.props.selectedPuff.id)
  //     // console.log("new puff selected")

  //     console.log("puff height now")
  //     console.log(prevPuffHeightNow)
  //     console.log("puff height before")
  //     console.log(prevProps.selectedPuff.height)
  //   }
  // }


  componentDidUpdate(prevProps, prevState){
    // console.log(this.props.feed.popularWidgets)
    let prev = prevProps.children
    let current = this.props.children
    let firstChunks = 2

    //Added to empty feed
    if(prev.length==0 && current.length>0){
      this.addMoreElements(true, firstChunks);
    }else if(prev.length > current.length){
      this.addMoreElements(true, firstChunks);
    }else{
      //Add when they're not identical
      for (let i = 0; i < prev.length; i++) {
        if(prev[i].key!==current[i].key){

          this.addMoreElements(true, firstChunks);
          break;
        }
      }
    }

  }

  addMoreElements(reset, nrOfChunks){
    let newContainers = [];
    let newChunkOffset = 0;
    nrOfChunks = nrOfChunks ? nrOfChunks : 1
    let chunkSize = this.state.chunkSize * nrOfChunks
    if(reset){
      this.props.thing ? null : this.refs.linearContainer.scrollTop = 0;
    }else{
      newContainers = this.state.containers.slice();
      newChunkOffset = this.state.chunkOffset;
    }

    let children = this.props.children;

    if(newContainers.length<=(children.length / chunkSize)) {
      let start = newChunkOffset*chunkSize;
      let stop = start + chunkSize;
      newContainers.push({
        elements:children.slice(start,stop),
        height: null,
        visible:true
      });
      // console.log("############################################")
      // let counter =0;
      // newContainers.map(c=>{c.elements.map(e=>{counter++})})
      // console.log(this.props.children.length, counter)
      this.setState({containers:newContainers, chunkOffset:newChunkOffset+nrOfChunks})
      
      if(start > children.length-5 && children.length>5){
        //Handle infinite scroll
        this.infiniteScroll(children.length)
      }
      
    };

   
  }

  infiniteScroll(offset){
    if(!this.props.feed.isFetching){
      console.log("FETCHING FOR "+this.props.feed.title)
      fetchFeed(this.props.feed, offset + (this.props.offset ? this.props.offset : 0))
    }
  }

  onScroll(){
    //If the list is empty
    if(this.refs.elementsContainer.childNodes[0] == undefined || this.state.chunkSize > this.props.children.length){
      return;
    }

    let scrollTop = this.refs.linearContainer.scrollTop;
    let lastElement = this.refs.elementsContainer.childNodes[this.refs.elementsContainer.childNodes.length-1];
    // console.log(scrollTop)

    // if(scrollTop>100 && this.state.top){
    //   this.setState({top:false})
    // }else if(scrollTop<100 && !this.state.top){
    //   this.setState({top:true})
    // }

    //If it's reached the last container and should fill it up at the bottom
    if(lastElement && scrollTop>(lastElement.offsetTop-this.refs.linearContainer.clientHeight)){
      this.addMoreElements();
      return;
    }

    //calculate which chunks to show:
    let viewHeight = this.refs.linearContainer.clientHeight;
    let scrollBottom = scrollTop+viewHeight;
    let newContainers = this.state.containers.slice();
    let changed = false;
    let shouldBeVisible = [];

    for (let i = 0; i < this.state.containers.length; i++) {

      let element = this.refs["chunk"+i];
      let top = element.offsetTop;
      let height = element.clientHeight;
      let bottom = top+height;
      //TODO: create points to listen to instead of doing this search all the time
      if((scrollTop>top&&scrollTop<bottom)||(scrollBottom>top&&scrollBottom<bottom)||(scrollTop<top&&scrollBottom>bottom)){
        //should be visible
        shouldBeVisible.push(i);
      }
    };

    if(!shouldBeVisible.length) return;

    if(shouldBeVisible[0] != 0){
      shouldBeVisible.splice(0,0,shouldBeVisible[0]-1)
    }
    
    if(shouldBeVisible[shouldBeVisible.length-1] != this.state.containers.length-1){
      shouldBeVisible.push(shouldBeVisible[shouldBeVisible.length-1]+1)
    }
    for (let i = 0; i < newContainers.length; i++) {
      if(shouldBeVisible.indexOf(i)!=-1){
        if(!newContainers[i].visible){
          newContainers[i].height = 0;
          newContainers[i].visible = true;
          changed = true;
        }
      }else{
        if(newContainers[i].visible){
          newContainers[i].height = parseFloat(getComputedStyle(this.refs["chunk"+i]).height)
          newContainers[i].visible = false;
          changed = true;
        }
      }
      
    };
    if(changed){
      this.setState({containers:newContainers});
    }
  }
  handleRefresh(resolve, reject) {
    // do some async code here 
     setTimeout(function () {
        console.log("done")
        resolve();
      }, 10000);
    // if (true) {
    //   resolve();
    // } else {
    //   reject();
    // }
  }
  
  // deselectPuffs(){
    // store.dispatch(setFocusedPuff(0));
  // }

  // scrollTo(top){
  //   // this.refs.linearContainer.scrollTop = top;
  // }

  render() {
    let self = this

    const style = {
      linearContainer:{
        overflowY :'scroll',
        WebkitOverflowScrolling: 'touch',
        position:'absolute',
        height:'100%',
        width:'100%',
        // backgroundColor: 'rgb(234, 234, 234)'
      },
      row:{display: 'flex', flexDirection: 'column'},
      spinner:{
        margin: 'auto',
        padding:30,
        textAlign: 'center',
        height:200
      },
      elementsContainer:{
        padding:0,
        paddingBottom:200,
        maxWidth:600,
        minWidth:300,
        // backgroundColor: '#eaeaea'
      },
      noResultsFound:{
        width: "100%",
        textAlign: "center",
        marginTop: "15px",
        color: "rgb(119, 119, 119)"
      }
    }
    const noResultsFound = (this.props.feed&&this.props.feed.lastRequest.query&&this.props.children.length===0 && !this.props.feed.isFetching)
    // const searchPage = (this.props.feed && this.props.feed.id==='search' && this.props.children.length===0 )
    let feedConfig = this.props.feed && this.props.feed.plugins && this.props.feed.categoryFilter

    return (
      //Id is for auto-scroll
            // <div className="submenu" style={{position:'fixed', left:0,right:0,height:40, top:0, zIndex:10, boxShadow: (this.state.top ? '' : 'rgba(0, 0, 0, 0.5) 0px 1px 20px 0px')}}/>
      // <div className="submenu" style={{position:'fixed', left:0,right:0,height:40, top:0, zIndex:10, boxShadow: (this.state.top ? '' : 'rgba(0, 0, 0, 0.5) 0px 1px 20px 0px')}}/>

      // <div  ref={(input) => {self.parentScroll = input }} id={self.props.scrollId} ref="linearContainer" style={style.linearContainer} onMouseDown={this.deselectPuffs}>
      <div>
      <div  ref={self.myRef} onScroll={self.props.updateScroll} id={self.props.scrollId} ref="linearContainer" style={{...style.linearContainer, ...(this.props.thing ? {} : style.row)}} onMouseDown={self.deselectPuffs}>

      {!feedConfig && !self.props.thing && self.props.feed.info && !noResultsFound ? <Infobox loading={self.props.feed.isFetching} feed={self.props.feed} info={self.props.feed.info}/> : null}

      {self.props.thing || (self.props.feed && self.props.feed.plugins && self.props.feed.categoryFilter) ?   
        <div className="container"  style={{...style.elementsContainer, maxWidth:1170, paddingBottom:0}}>

            {self.props.feed && (!self.props.thing) && self.props.feed.plugins && self.props.feed.categoryFilter  ? <Config feed={self.props.feed} 
                                                                                                      id={self.props.feed.id}
                                                                                                      feedMenu={self.props.feed}
                                                                                                      simple={true}
                                                                                                      selected={true}
                                                                                                      style={{marginTop:20, padding:'15px 20px'}}
                                                                                                      publications={[]}/> : null}
            {self.props.thing ? self.props.thing : null}
        </div> 
      : null}

      <div ref="elementsContainer" className="container"  style={{...style.elementsContainer,...self.props.style}}> 
        


            {self.props.message ? self.props.message : null}
         {self.state.containers.map((chunk,index)=>{return (
            <div style={(chunk.height?{height:chunk.height}:{})} ref={"chunk"+index} key={self.props.id+"-linear"+index}>
              <div style={(chunk.visible?{}:{display:'none'})} >
                {chunk.elements}
              </div>
            </div>
          )})}
          {self.props.feed.isFetching ? <div style={style.spinner}><Spinner/></div>:null}
      </div>
        {self.props.feed.isFetching || !self.props.thing || self.props.feed.puffs.length<30 ? null : <p className="blackButton button" style={{
                      width: 'fit-content',
                      margin: '-150px auto 150px',
                      fontSize: 'large',
                      display: 'block'
                }} onClick={()=>{self.infiniteScroll(0)}}>Show More Articles</p>}
      </div>
      </div>
  
    );
  }

}



const mapStateToProps = function(store) {
  return {
    selectedPuff: store.puff.selectedPuff
  };
};

export default connect(mapStateToProps)(Linear);